export const ADYEN_ENVIRONMENT_TEST = 'test';
export const ADYEN_ENVIRONMENT_LIVE = 'live';
